/**
 * 소수점 계산을 편하게 하기 위해 App, API 와 협의한 만분율. 최대 RATE 는 만분율로 저장한다
 */
const MAX_RATE = 10000;
export function restoreFromLastViewRate({
  rate,
  total,
}: {
  rate: number;
  total: number;
}) {
  // 서버로 rate 를 보낸 적이 없다면 undefined 가 들어올 수 있습니다. 정상 상황이므로 0을 리턴합니다
  if (rate === undefined) {
    return 0;
  }

  // 일어날 일 없지만 혹시나 NaN 가 들어와도 사용자에게 에러화면을 보여줄 필요는 없으니 에러가 아니라 0을 리턴합니다. 단, 예외적인 상황이니 로그는 남깁니다.
  if (isNaN(rate) || isNaN(total)) {
    // TODO: 잘못된 인자 에러 전송
    return 0;
  }
  if (!rate || !total || rate < 0) {
    return 0;
  }
  if (rate >= MAX_RATE) {
    return total;
  }
  // 17 페이지 중 16 페이지일 경우 rate는 9411이 되나 이를 복구하면 15.9987 페이지라 정확히 복구할 수 없습니다.
  // 따라서 수치를 엄밀하게 복구하지 않고 반올림해서 근사값을 사용합니다.
  const result = Math.round((rate * total) / MAX_RATE);
  return result > total ? total : result;
}
